import type { CSS } from '@grupoboticario/flora-react'

import { linkAction, finisheCampaignAction, NO_TOKEN_COLORS } from './styles'

export const emptyStateCss: CSS = {
  height: '200px'
}

export const emptyStateTextCss: CSS = {
  padding: '$8',
  textAlign: 'center'
}

export const getLinkActionCss = (): CSS => ({
  ...linkAction,
  color: NO_TOKEN_COLORS.BLUE
})

export const getFinishActionCss = (isAble: boolean): CSS => ({
  ...(isAble ? finisheCampaignAction.able : finisheCampaignAction.disabled),
  color: isAble ? NO_TOKEN_COLORS.RED : NO_TOKEN_COLORS.GRAY
})

export const getEditActionCss = (isAble: boolean): CSS => ({
  color: isAble ? NO_TOKEN_COLORS.BLUE : NO_TOKEN_COLORS.GRAY
})
